import { FC, ReactNode } from "react";
import { useStyles } from "./RegtankResponseLayout.styles";
import BackImage from "@funded-here-interface/common/src/assets/sideBackground.svg";
import { ToastContainer } from "react-toastify";
import NavBar from "../../components/NavBar/NavBar";
interface IProps {
  content: ReactNode;
  showLogo?: boolean;
}

const RegtankResponseLayout: FC<IProps> = ({ content, showLogo = true }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.mainContainer}>
      <div className={classes.sidebar}>
        <NavBar />
        <ToastContainer />
      </div>
      <div className={classes.leftContainer}>
        <div className={classes.pageContainer}>
          <div className={classes.stepContent}>{content}</div>
        </div>
      </div>
      <div className={classes.backImage}>
        <img src={BackImage} alt="" />
      </div>
    </div>
  );
};

export default RegtankResponseLayout;
